// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ReadingCardController from "./reading_card_controller"
application.register("reading-card", ReadingCardController)

import ReadingFormController from "./reading_form_controller"
application.register("reading-form", ReadingFormController)

import LipidPanelFormController from "./lipid_panel_form_controller"
application.register("lipid-panel-form", LipidPanelFormController)

import ExpandableInfoController from "./expandable_info_controller"
application.register("expandable-info", ExpandableInfoController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import HeightInputController from "./height_input_controller"
application.register("height-input", HeightInputController)

import WeightInputController from "./weight_input_controller"
application.register("weight-input", WeightInputController)

import TocController from "./toc_controller"
application.register("toc", TocController)

import TrixToolbarController from "./trix_toolbar_controller"
application.register("trix-toolbar", TrixToolbarController)

import CalculatorController from "./calculator_controller"
application.register("calculator", CalculatorController)
